import { getStore, setStore, removeStore } from './sessionStorage';

export function clearUserName() {
    removeStore("LOGIN_USER_NAME");
}
export function setUserName(name) {
    setStore("LOGIN_USER_NAME", name);
}
export function getUserName() {
    return getStore("LOGIN_USER_NAME");
}
export function clearUserSign() {
    removeStore("LOGIN_USER_SIGN");
}
export function setUserSign(token) {
    setStore("LOGIN_USER_SIGN", token);
}
export function getUserSign() {
    return getStore("LOGIN_USER_SIGN");
}
export function setNotice(flag) {
    setStore("NOTICE", flag);
}
export function getNotice() {
    return getStore("NOTICE");
}
export function setIpValid(result) {
    if(result.result){
        setStore("IP_VALID", true);
    }else{
        setStore("IP_VALID", false);
    }
}
export function getIpValid() {
    // return true;
    return getStore("IP_VALID");
}


export function getChatRecord() {
    return getStore("CHAT_QAI");
}
export function setChatRecord(data) {
    setStore("CHAT_QAI",data);
}